import React, { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
export function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);
  const {
    t
  } = useLanguage();
  const faqs = t('faq.items');
  return <section className="w-full py-16 px-6 md:px-12 bg-[var(--color-bg)]" data-id="element-330">
      <div className="max-w-7xl mx-auto" data-id="element-331">
        <div className="flex flex-col lg:flex-row gap-12" data-id="element-332">
          {/* Left side */}
          <div className="lg:w-2/5" data-id="element-333">
            {/* FAQ pill */}
            <div className="inline-block px-4 py-1.5 border border-gray-300 rounded-full mb-6 bg-white" data-id="element-334">
              <span className="text-sm font-medium text-[var(--color-text-dark)]" data-id="element-335">
                {t('faq.pill')}
              </span>
            </div>

            <h2 className="text-3xl font-bold text-[var(--color-text-dark)] mb-4" data-id="element-336">
              {t('faq.title')}
            </h2>
            <p className="text-[var(--color-text-light)] text-sm mb-6" data-id="element-337">
              {t('faq.desc')}
            </p>

            {/* Mobile: FAQ accordion */}
            <div className="lg:hidden mb-8" data-id="element-338">
              <div className="bg-white rounded-2xl p-6 border border-gray-200" data-id="element-339">
                <div className="space-y-0" data-id="element-340">
                  {faqs.map((faq: any) => <div key={faq.id} className="border-b border-gray-100 last:border-0" data-id="element-341">
                      <button onClick={() => setOpenId(openId === faq.id ? null : faq.id)} className="w-full py-4 flex items-start justify-between text-left gap-4" aria-expanded={openId === faq.id} data-id="element-342">
                        <div className="flex gap-3 flex-1" data-id="element-343">
                          <span className="text-[var(--color-text-light)] font-medium text-sm flex-shrink-0" data-id="element-344">
                            {faq.id}
                          </span>
                          <h3 className="text-sm font-medium text-[var(--color-text-dark)]" data-id="element-345">
                            {faq.q}
                          </h3>
                        </div>
                        <div className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${openId === faq.id ? 'bg-[var(--color-tan)]' : 'bg-gray-100'}`} data-id="element-346">
                          <svg className={`w-3.5 h-3.5 transition-colors ${openId === faq.id ? 'text-white' : 'text-gray-500'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-347">
                            {openId === faq.id ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" data-id="element-348" /> : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" data-id="element-349" />}
                          </svg>
                        </div>
                      </button>
                      <div className={`overflow-hidden transition-all duration-200 ${openId === faq.id ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-350">
                        <p className="pl-8 pb-4 text-sm text-[var(--color-text-light)]" data-id="element-351">
                          {faq.a}
                        </p>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
          </div>

          {/* Right side - FAQ accordion (Desktop only) */}
          <div className="hidden lg:block lg:w-3/5" data-id="element-352">
            <div className="bg-white rounded-2xl p-6 md:p-8 border border-gray-200" data-id="element-353">
              <div className="space-y-0" data-id="element-354">
                {faqs.map((faq: any) => <div key={faq.id} className="border-b border-gray-100 last:border-0" data-id="element-355">
                    <button onClick={() => setOpenId(openId === faq.id ? null : faq.id)} className="w-full py-5 flex items-start justify-between text-left gap-4" aria-expanded={openId === faq.id} data-id="element-356">
                      <div className="flex gap-4 flex-1" data-id="element-357">
                        <span className="text-[var(--color-text-light)] font-medium text-sm flex-shrink-0" data-id="element-358">
                          {faq.id}
                        </span>
                        <h3 className="text-base font-medium text-[var(--color-text-dark)]" data-id="element-359">
                          {faq.q}
                        </h3>
                      </div>
                      <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${openId === faq.id ? 'bg-[var(--color-tan)]' : 'bg-gray-100'}`} data-id="element-360">
                        <svg className={`w-4 h-4 transition-colors ${openId === faq.id ? 'text-white' : 'text-gray-500'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-361">
                          {openId === faq.id ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" data-id="element-362" /> : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" data-id="element-363" />}
                        </svg>
                      </div>
                    </button>
                    <div className={`overflow-hidden transition-all duration-200 ${openId === faq.id ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-364">
                      <p className="pl-10 pb-5 text-sm text-[var(--color-text-light)]" data-id="element-365">
                        {faq.a}
                      </p>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}